export const API_URL =
    'https://apiservices.unosolindia.com/SSMCommerceNewSupport/SSMCommerceAPI.svc/';
// export const MERCHANT_CODE = 'USTAA02002';
export const MERCHANT_CODE = 'KHIDM02004';
